let isPrint = false;
const originalMetaViewport = document.getElementsByTagName("meta")["viewport"].content;

/**
 * Generates the screenshots and displays the print version on completion
 */
export const showPrintVersion = () => {
  window.scrollTo(0,0);
  isPrint = true;
}

/**
 * Force viewport on mobile devices to be bigger
 */
export const forceBiggerViewport =  () => {
  document.getElementsByTagName("meta")["viewport"].content = `${originalMetaViewport}, width=1250`;
}

/**
 * Return viewport on mobile devices to its original value
 */
export const setOriginalDeviceViewport =  () => {
  document.getElementsByTagName("meta")["viewport"].content = originalMetaViewport;
}

export const setDeviceSizeToModal = () => {
  const modalElement =  document.getElementById("nppe2-fc-feeding-guidelines-output");
  if (modalElement) {
    modalElement.style.width = window.visualViewport.width + "px"
    modalElement.style.height = window.visualViewport.height + "px"
  }
}

/**
 * Hides the print version of the feeding guidelines, displays the HTML version
 */
export const hidePrintVersion = () => {
  isPrint = false;
  const feedingGuidelinesPrint = document.getElementById("feeding-guidelines-print");
  const feedingGuidelines = document.getElementById("feeding-guidelines");
  if (feedingGuidelinesPrint) feedingGuidelinesPrint.style.display = 'none';
  if (feedingGuidelines) feedingGuidelines.style.display = 'block';
}

export const togglePrintVersion = () => {
  isPrint ? hidePrintVersion() : showPrintVersion();
}
